import { request } from '@/common/utils/request'
import { getBDCountry, getBDTimezone } from '@/common/utils/i18n'
export const getCommonParams = function () {
  return {
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}

export default {
  getTaskList(params) {
    return request.post({
      url: 'feidian.task.task.list',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskCount(params) {
    return request.post({
      url: 'feidian.task.task.getCount',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskConfig(params) {
    return request.post({
      url: 'feidian.task.config',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskTypeList(params) {
    return request.post({
      url: 'feidian.task.taskType.list',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskDetail(params) {
    return request.post({
      url: 'feidian.task.task.get',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskTypeDetail(params) {
    return request.post({
      url: 'feidian.task.taskType.get',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskUpdate(params) {
    return request.post({
      url: 'feidian.task.task.update',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskRemind(params) {
    return request.post({
      url: 'feidian.task.task.noRemind',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskRejectRemind(params) {
    return request.post({
      url: 'feidian.task.task.remindRead',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskEdit(params) {
    return request.post({
      url: 'feidian.task.task.edit',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskReject(params) {
    return request.post({
      url: 'feidian.task.task.reject',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getShopIndicator(params) {
    return request.post({
      url: 'feidian.task.task.getShopIndicator',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getTaskCreate(params) {
    return request.post({
      url: 'feidian.task.task.create',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  // feidian.task.taskRemark.list
  getTaskRemarkList(params) {
    return request.post({
      url: 'feidian.task.taskRemark.list',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
}
